import { Component } from "@angular/core";

@Component({
  selector: "app-no-column-info",
  templateUrl: "./no-column-info.component.html",
  styleUrls: ["./no-column-info.component.scss"],
})
export class NoColumnInfoComponent {}
